import * as React from "react";
const SvgTriangle = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10, height: 10, viewBox: "0 0 10 10", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#000000", fillRule: "evenodd", d: "M5 8.333L0 1.667h10z" }));
export default SvgTriangle;
